import { render } from "./AddBlog_old.vue?vue&type=template&id=1ea82e18"
import script from "./AddBlog_old.vue?vue&type=script&lang=js"
export * from "./AddBlog_old.vue?vue&type=script&lang=js"

import "./AddBlog_old.vue?vue&type=style&index=0&id=1ea82e18&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__